export default {"src":"/_next/static/media/fonds21.2b495caf.svg","height":32,"width":154,"blurWidth":0,"blurHeight":0};